import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Settings as SettingsIcon, Mail, Phone, Shield } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl">Настройки</h1>
        <p className="text-slate-400 mt-1 text-sm">Данные вашей учётной записи</p>
      </div>

      <Card className="p-6 bg-[#131924] border-[#212b3d] max-w-md">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center text-amber-400 font-semibold text-lg">
            {user?.name?.[0] ?? "?"}
          </div>
          <div className="min-w-0">
            <div className="font-display font-semibold text-slate-100 truncate">{user?.name}</div>
            <div className="text-xs text-slate-500 flex items-center gap-1">
              <Shield size={11} /> {user?.role === "admin" ? "Владелец / Админ" : "Мастер / Рабочий"}
            </div>
          </div>
        </div>
        <div className="space-y-2 text-sm">
          {user?.email && (
            <div className="flex items-center gap-2 text-slate-300">
              <Mail size={14} className="text-slate-500" /> {user.email}
            </div>
          )}
          {user?.phone && (
            <div className="flex items-center gap-2 text-slate-300">
              <Phone size={14} className="text-slate-500" /> {user.phone}
            </div>
          )}
        </div>
      </Card>

      <Card className="p-6 bg-[#131924] border-[#212b3d] max-w-md text-sm text-slate-500 flex items-start gap-3">
        <SettingsIcon size={16} className="mt-0.5 flex-shrink-0 opacity-60" />
        <span>Расширенные настройки системы появятся здесь позже.</span>
      </Card>
    </div>
  );
}
